export default __webpack_public_path__ + "static/media/Loop of the Hell Walker.e35dffba.jpg";